/**
 * Pro subscription billing client. Separate from garment order checkout.
 */
import { getAuthHeaders, API_BASE_URL } from './usageService'
import { suppressUnloadPrompt } from '../utils/unloadGuard'
import { errorFromApi } from '../utils/customerError'

function returnOrigin() {
  if (typeof window === 'undefined') return undefined
  return window.location.origin
}

export async function startProCheckout() {
  const headers = await getAuthHeaders()
  const res = await fetch(`${API_BASE_URL}/billing/checkout`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ returnOrigin: returnOrigin() })
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw errorFromApi(data, res.status, "We couldn't start checkout. Please try again.")
  }
  if (!data.url) throw new Error("We couldn't start checkout. Please try again.")
  suppressUnloadPrompt()
  window.location.assign(data.url)
  return data
}

export async function openBillingPortal() {
  const headers = await getAuthHeaders()
  const res = await fetch(`${API_BASE_URL}/billing/portal`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ returnOrigin: returnOrigin() })
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw errorFromApi(data, res.status, "We couldn't open billing. Please try again.")
  }
  if (!data.url) throw new Error("We couldn't open billing. Please try again.")
  suppressUnloadPrompt()
  window.location.assign(data.url)
  return data
}

export async function syncBillingCheckout(sessionId) {
  const headers = await getAuthHeaders()
  const res = await fetch(`${API_BASE_URL}/billing/sync`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ sessionId })
  })
  const data = await res.json().catch(() => ({}))
  if (!res.ok) {
    throw errorFromApi(data, res.status, "We couldn't confirm your plan yet. Please refresh in a moment.")
  }
  return data
}
